import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isMaintenanceMode, isAllowedRoute } from '../../utils/maintenance';

const MaintenanceWrapper = ({ children }) => {
  const location = useLocation();
  
  // If maintenance mode is enabled and current route is not allowed
  if (isMaintenanceMode() && !isAllowedRoute(location.pathname)) {
    return <Navigate to="/maintenance" replace />;
  }
  
  // Otherwise, render the children normally
  return children;
};

export default MaintenanceWrapper;
